import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { FontSize } from '../../../lib/style/ThemeStyle';

export const Input = ({
  type = 'text',
  placeholder,
  name,
  value,
  onChange,
  ...props
}) => {
  return (
    <InputStyle
      type={type}
      value={value}
      name={name}
      placeholder={placeholder}
      onChange={onChange}
      size={16}
      {...props}
    />
  );
};

Input.propTypes = {
  type: PropTypes.string,
  value: PropTypes.any,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
};

const InputStyle = styled.input`
  width: 100%;
  ${FontSize}
  padding: 0  1rem;
  color: ${(props) => props.theme.color.darkest};

  ::placeholder {
    color: ${(props) => props.theme.color.pinkishGrey};
    font-size: 0.875rem;
  }
`;

export const OnlyInput = styled(Input)`
  flex: ${(props) => props.flex};
  padding: 0.625rem 1rem;
  border-radius: 6px;
  border: 1px solid
    ${(props) =>
      props.active
        ? props.theme.color.orangePink
        : props.theme.color.pinkishGrey};
  background: ${(props) => props.theme.background[props.background]};

  & + & {
    margin-top: 0.688rem;
  }
`;
